import { render } from "./StoreOfferTasks.vue?vue&type=template&id=289a45f6"
import script from "./StoreOfferTasks.vue?vue&type=script&lang=js"
export * from "./StoreOfferTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__